<template>
    <div class="menu-wrapper">
        <div class="menu-title">
            <h1>Mr. Ynk Games Libary</h1>
        </div>

        <router-link :to="{ name: 'Game', params: { gameID: game.gameID } }" v-for="game in games" :key="game.gameID">
            <div class="game-block">
                <div class="game-content">
                    <h3>{{ game.name }}</h3>
                    <p>{{ game.description }}</p>
                </div>
                <div class="game-image">
                    <img :src="game.shareImage" :alt="game.description">
                </div>
            </div>
        </router-link>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    export default {
        name: 'Landing',

        computed: {
            games()
            {
                return this.$store.getters[ 'game/games' ]; // all
            }
        }
    };
</script>
